/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React from 'react'
import { Footer } from 'flowbite-react';
import { BsDribbble, BsFacebook, BsGithub, BsInstagram, BsTwitter,BsLinkedin,BsYoutube,BsSkype,BsPinterest,BsTelegram } from 'react-icons/bs';
import { Link } from 'react-router-dom';

function Footersection() {
  return (
   <> 
    <Footer className='bg-black' >
      <div className="w-full">
        <div className="grid w-full grid-cols-2 gap-8 px-6 py-8 md:grid-cols-4">
          <div>
            <Footer.Title className='text-white' title="Company" />
            <Footer.LinkGroup className='text-white' col>

             <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/about" 
>   <Footer.Link href="/About" >About</Footer.Link> </Link>
             
             
<Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/Blog" 
> 
 <Footer.Link >Blog</Footer.Link> </Link>
            </Footer.LinkGroup>
          </div>
          <div>
            <Footer.Title className='text-white' title="help center" />
            <Footer.LinkGroup className='text-white' col>
              <Footer.Link href="mailto:support@sitekitpro.com">Support </Footer.Link> 
            
              <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/Contact" 
> 
              <Footer.Link >Contact Us</Footer.Link> 
</Link>
 
            </Footer.LinkGroup>
          </div>
          <div>
            <Footer.Title className='text-white' title="legal" />
            <Footer.LinkGroup className='text-white' col>
              
            <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/Privacy" 
>    <Footer.Link >Privacy Policy</Footer.Link> 

</Link>
             
<Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/Terms" 
>  

 <Footer.Link >Terms &amp; Conditions</Footer.Link>

 </Link>
            </Footer.LinkGroup>
          </div>
          <div>
            <Footer.Title className='text-white' title="Sitekit Templates " />
            <Footer.LinkGroup className='text-white' col>
            <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/Sitekitthemes" 
>  

 <Footer.Link > Sitekit Themes </Footer.Link> </Link>

 <Link onClick={() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    }); 
  }} to="/Plugins" 
>  

              <Footer.Link > Plugins  </Footer.Link>  </Link>
              
            </Footer.LinkGroup>
          </div>
        </div>
        <div className="w-full bg-orange-700 bg-opacity-100 px-4 py-6 sm:flex sm:items-center sm:justify-between">
          <Footer.Copyright className='text-white' href="mailto:support@sitekitpro.com"  target="_blank" by="SitekitPro " year={2025} /><br></br>
          <div className="mt-4 flex space-x-6 sm:mt-0 sm:justify-center">
            <Footer.Icon className='text-white' target='_blank' href="https://www.facebook.com/sitekitpro" icon={BsFacebook} />
            <Footer.Icon className='text-white' target='_blank' href="https://www.instagram.com/sitekitpro_official/" icon={BsInstagram} />
            <Footer.Icon className='text-white' target='_blank' href="https://x.com/sitekitpro" icon={BsTwitter} />
            <Footer.Icon className='text-white' target='_blank' href="https://www.youtube.com/@sitekitpro" icon={BsYoutube} />
            <Footer.Icon className='text-white' target='_blank' href="https://www.linkedin.com/company/sitekitpro/" icon={BsLinkedin} />
            <Footer.Icon className='text-white' target='_blank' href="https://t.me/sitekitpro" icon={BsTelegram} />
            <Footer.Icon className='text-white' target='_blank'href="https://www.pinterest.com/sitekirpro/" icon={BsPinterest} />
            <Footer.Icon className='text-white' target='_blank' href="https://join.skype.com/invite/xg7T8GgE79pL" icon={BsSkype} />
          </div>
        </div>
      </div>
    </Footer>
  

   </>
  )
}

export default Footersection